import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

import {getStats} from "../../components/helpers/StatsHelpers";
import FeaturesMatrix from "./FeaturesMatrix";
import {RiFlaskFill, RiTeamLine, RiUser3Line} from "react-icons/ri";
import {SeoHelper} from "../../components/helpers/SeoHelper";
import {FALLBACK_PRICES, formatPrice, getSubscriptionPrices} from "../../components/helpers/PricingHelpers";

class PlansAndPricing extends React.Component {
  state = {
    songBookCount: null,
    prices: FALLBACK_PRICES,
    pricesLoading: true
  };

  constructor(props) {
    super(props);
    getStats.call(this);

    sessionStorage.removeItem("clientSecret");
    // sessionStorage.removeItem("customer");
  }

  componentDidMount() {
    getSubscriptionPrices().then(prices => {
      this.setState({prices, pricesLoading: false});
    });
  }

  render() {
    const {prices, pricesLoading} = this.state;
    const priceLabel = (value) => pricesLoading ? "Loading..." : formatPrice(value);

    return (
      <>
        <SeoHelper
            uri="/plans-and-pricing"
            title="Plans and Pricing | The Worship Bible"
            description="Simple, transparent pricing for The Worship Bible. Build unlimited worship song-flows and plan services with ease."
        />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span className="d-block text-white">
                          plans &amp; pricing
                        </span>
                      </h1>

                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                  <Row className="justify-content-center mb-0 mt-2">
                    <Col lg="9">
                      <div
                          style={{
                            background: "rgba(255,255,255,0.95)",
                            borderRadius: "0.5rem",
                            padding: "2rem",
                            textAlign: "center"
                          }}
                      >
                        <p className="lead font-weight-normal mb-2 mt--1 text-primary">
                          Simple, transparent pricing to help you plan worship with clarity and confidence.
                        </p>

                        <p className="text-muted mb-2" style={{ maxWidth: "720px", margin: "0 auto" }}>
                          Whether you are exploring a single service or planning week by week,
                          The Worship Bible supports the whole Act of Worship — without complexity or hidden costs.
                        </p>

                        <p className="text-muted mb-0">
                          Clear pricing, no hidden costs — and responsible handling of your data.
                          Learn more about our{" "}
                          <a href="/security">Security &amp; Data Protection</a>.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
              <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid" style={{alignItems: 'stretch'}}>
                    <Col lg="3" className="d-flex">
                      <Card className="card shadow border-0 w-100">
                        <CardBody className="py-5 d-flex flex-column">
                          <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                            <RiFlaskFill color='#5e72e4' size="36"/>&nbsp;Try before you buy<br/><br/>Free — no credit card required
                          </h2>
                          <p className="description mt-3">
                            Try The Worship Bible free — no credit card required. Build as many worship plans as you like. Share up to 3 times, each with as many people as you need.
                          </p>
                          <Button
                              className="mt-auto"
                              color="primary"
                              href="/"
                          >
                            Get started
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="3" className="d-flex">
                      <Card className="card shadow border-0 w-100">
                        <CardBody className="py-5 d-flex flex-column">
                          <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                            <RiUser3Line color="#5e72e4" size="36"/>
                            &nbsp;Single User<br/><br/>
                            {priceLabel(prices.individual.monthly)} per month or {priceLabel(prices.individual.annual)} per year
                          </h2>
                          <p className="description mt-3">
                            Build, save, and edit unlimited curated song-flows using all of our
                            {" "}
                            {!sessionStorage.getItem("statsTtl")
                                ? ""
                                : JSON.parse(sessionStorage.getItem("statsTtl"))
                                    .stats.find(x => x.title === "Song Books").value}{" "}
                            song books — ideal for individual worship leaders and planners.
                          </p>
                          <p className="description mt-2">
                            Cancel anytime. No long-term commitment.
                          </p>
                          <Button
                              className="mt-auto"
                              color="primary"
                              href="/register/choose-your-plan"
                          >
                            Get started
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="3" className="d-flex">
                      <Card className="card shadow border-0 w-100">
                        <CardBody className="py-5 d-flex flex-column">
                          <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                            <RiTeamLine color='#5e72e4' size="36"/>&nbsp;Group<br/><br/>
                            {priceLabel(prices.group.annual)} per year
                          </h2>
                          <p className="description mt-3">
                            Plan worship together with up to 10 members. A Group subscription gives everyone access —
                            invite others, share song-flows, and plan services collaboratively.
                          </p>
                          <p className="description mt-2">
                            Annual billing only. Built for small churches and music teams.
                          </p>
                          <Button
                              className="mt-auto"
                              color="primary"
                              href="/register/multi"
                          >
                            Get started
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="3" className="d-flex">
                      <Card className="card shadow border-0 w-100">
                        <CardBody className="py-5 d-flex flex-column">
                          <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                            <RiTeamLine color='#5e72e4' size="36"/>&nbsp;Organisation<br/><br/>
                            {priceLabel(prices.enterprise.annual)} per year admin fee
                          </h2>
                          <p className="description mt-3">
                            Unlimited seats. Built for dioceses, denominations, and institutions
                            coordinating worship planning across multiple teams.
                          </p>
                          <p className="description mt-2">
                            Plus £1.67 per active seat per month, billed monthly.
                          </p>
                          <Button
                              className="mt-auto"
                              color="primary"
                              href="/register/enterprise"
                          >
                            Register your organisation
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
          <FeaturesMatrix/>
        {/*</main>*/}
        
      </>
    );
  }
}

export default PlansAndPricing;
